import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { handleAuthCallback } from '../services/auth'

// Handles the Casdoor OAuth redirect back to the landing page. Exchanges the
// code, provisions/loads the OpenDeploy account, then returns the user to
// wherever they triggered sign-in from (e.g. the event page, to finish a vote).
export default function AuthCallbackPage() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let active = true
    handleAuthCallback()
      .then((returnTo) => {
        if (active) navigate(returnTo, { replace: true })
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err.message : 'Sign-in failed.')
      })
    return () => {
      active = false
    }
  }, [navigate])

  return (
    <div className="od-event-page od-blog-light od-event-light">
      <div className="od-event-detail-frame">
        {error ? (
          <p className="od-event-state">
            {error} <Link to="/events">Back to events</Link>.
          </p>
        ) : (
          <p className="od-event-state">Signing you in…</p>
        )}
      </div>
    </div>
  )
}
